import styled from 'styled-components';

const ContentStyle = styled.section`
	--distanceCategoryTB: var(--sp6x);
	--distanceEditorTB: var(--sp6x);
	--shareDistance: var(--sp4x);

	.wrapper-category {
		display: flex;
		justify-content: space-between;
		padding: var(--distanceCategoryTB) 0;
		border-bottom: 2px solid var(--neutral600);
	}

	.wrapper-editor {
		padding: var(--distanceEditorTB) 0;
	}

	.wrapper-share {
		border-top: 2px solid var(--neutral600);
		padding-top: var(--shareDistance);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceCategoryTB: var(--sp4x);
		--distanceEditorTB: var(--sp5x);
		--shareDistance: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceCategoryTB: var(--sp3x);
		--distanceEditorTB: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceCategoryTB: var(--sp2x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--shareDistance: var(--sp2x);
		--distanceEditorTB: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceCategoryTB: var(--sp3x);
		--distanceEditorTB: var(--sp3x);

		padding: 0 var(--sp2x);
	}
`;
export default ContentStyle;
